import { Transform } from "../../../geometry/transformation";
import { getShapeTransfomer } from "./shapeCategorySingleton";


export function transformShape(shape: GeometricShape, transfromation: Transform = new Transform()): GeometricShape {

    const transformerTransMatrix = new Transform(shape.transformation).multiply(transfromation).m;
    const shapeWithNewTrans = { ...shape, transformation: transformerTransMatrix };
    const refreshedShape = recalculateShape(shapeWithNewTrans)
    return refreshedShape;
}

export function recalculateShape<T extends GeometricShape>(shape: T): T | GeometricShape {
    const shapeTransformerGroup = getShapeTransfomer(shape.type)
    if (shapeTransformerGroup) {

        const shapeWithSnapPoints: GeometricShape = {
            ...shapeTransformerGroup.snapPointCalculator(shape),
            ...shapeTransformerGroup.calculateWidthHeight(shape)
        };
        return shapeWithSnapPoints;
    } else {
        return shape;
    }
}